import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
@Directive({
  selector: '[appAutoFocus]'
})
export class AutoFocusDirective implements AfterViewInit {
  private _autofocus;
  constructor(private el: ElementRef) { }
  ngAfterViewInit() {

    if (this._autofocus || typeof this._autofocus === "undefined")
      this.el.nativeElement.focus();

  }

  ngOnInit() {
    if (this._autofocus || typeof this._autofocus === "undefined")
      this.el.nativeElement.focus();
  }

  @Input() set appAutoFocus(condition: boolean) {
    this._autofocus = condition != false;
  }
}